/**
 * 大屏（第 3 组）英文语言包（中文原文 → 英文 扁平映射）
 * 覆盖 src/views/bigScreen 第 43-62 个文件（水质分析/用水分析/工单模块/地图大屏/主框架）
 */
export default {
  // 通用
  '正常': 'Normal',
  '异常': 'Abnormal',
  '总计': 'Total',
  '全部': 'All',
  '关闭': 'Close',
  '个': 'pcs',
  '件': 'pcs',
  '处': 'sites',
  '度': '°',
  '共{total}条': 'Total {total} records',
  '智慧水务管理平台': 'Smart Water Management Platform',
  '系统首页': 'Home',
  // 水质模块
  '实时告警': 'Real-time Alarms',
  '水质指标分析': 'Water Quality Index Analysis',
  '今日水质指标分析': 'Today\'s Water Quality Index Analysis',
  '水质传感器工作情况': 'Water Quality Sensor Status',
  '总采集点': 'Total Collection Points',
  '水质达标率': 'Water Quality Compliance Rate',
  '在线': 'Online',
  '离线': 'Offline',
  '酸碱度': 'pH',
  'PH值': 'pH',
  '色度': 'Chroma',
  '浑浊度': 'Turbidity',
  '浊度': 'Turbidity',
  '溶解性总固体': 'Total Dissolved Solids',
  '硬度': 'Hardness',
  '氧化还原': 'ORP',
  '氯化物': 'Chloride',
  '余氯': 'Residual Chlorine',
  '硫酸盐': 'Sulfate',
  '高锰酸盐': 'Permanganate',
  '电导率': 'Conductivity',
  '水温': 'Water Temperature',
  '温度': 'Temperature',
  '温度值': 'Temperature',
  '溶解氧': 'Dissolved Oxygen',
  '氨氮': 'Ammonia Nitrogen',
  '化学耗氧量': 'Chemical Oxygen Demand',
  '低位告警线': 'Low Alarm Line',
  '高位告警线': 'High Alarm Line',
  // 用水分析
  '用水量分析': 'Water Consumption Analysis',
  '零流量用水': 'Zero-flow Water Use',
  '本年累计用水量': 'Annual Cumulative Water Consumption',
  '近七日': 'Last 7 Days',
  '本月': 'This Month',
  '上月': 'Last Month',
  '近一年月用水/缴费统计': 'Monthly Water Consumption/Payment (Last Year)',
  '用户近半年用水统计': 'Customer Water Consumption (Last 6 Months)',
  '各区域近一年用水分析': 'Water Use by Area (Last Year)',
  '用水量': 'Water Consumption',
  '缴费': 'Payment',
  '用量(m³)': 'Usage (m³)',
  '缴费(元)': 'Payment (CNY)',
  // 工单模块
  '基本信息': 'Basic Information',
  '本月工单(件)': 'Work Orders This Month (pcs)',
  '本周工单(件)': 'Work Orders This Week (pcs)',
  '昨日工单(件)': 'Work Orders Yesterday (pcs)',
  '待处理工单(件)': 'Pending Work Orders (pcs)',
  '业务趋势': 'Business Trends',
  '换表': 'Meter Replacement',
  '工程报装': 'Engineering Installation',
  '故障报修': 'Fault Repair',
  '近七天': 'Last 7 Days',
  '近一月': 'Last Month',
  '近半年': 'Last 6 Months',
  '工单数': 'Work Orders',
  '工单数(件)': 'Work Orders (pcs)',
  '完结率(%)': 'Completion Rate (%)',
  '本月工单处理进度': 'Work Order Processing Progress This Month',
  '已处理': 'Processed',
  '实时数据': 'Real-time Data',
  '序号': 'No.',
  '工单类型': 'Work Order Type',
  '工单紧急程度': 'Work Order Urgency',
  '工单联系人': 'Work Order Contact',
  '联系电话': 'Contact Phone',
  '申请人': 'Applicant',
  '申请时间': 'Application Time',
  '来源': 'Source',
  '工单状态': 'Work Order Status',
  '紧急': 'Urgent',
  '小程序': 'Mini Program',
  '公众号': 'Official Account',
  '已结束': 'Finished',
  '未开启': 'Not Started',
  '换表登记': 'Meter Replacement Registration',
  '旧表审核': 'Old Meter Review',
  '绑定新表': 'Bind New Meter',
  '安装': 'Install',
  '审核工单': 'Work Order Review',
  '报装申请': 'Installation Application',
  '报装受理': 'Installation Acceptance',
  '报装勘察设计': 'Installation Survey & Design',
  '报装预算': 'Installation Budget',
  '报装审批': 'Installation Approval',
  '报装收费': 'Installation Fee Collection',
  '报装施工': 'Installation Construction',
  '报装验收': 'Installation Final Acceptance',
  '报装建档': 'Installation Filing',
  '接单': 'Accept',
  '处理': 'Handle',
  '归档': 'Archive',
  // 地图大屏（photoDevice）
  '一张图': 'One Map',
  '水表': 'Water Meter',
  '压力': 'Pressure',
  '液位': 'Liquid Level',
  '流量': 'Flow',
  '水质': 'Water Quality',
  '控压阀': 'Pressure Control Valve',
  '停漏水': 'Water Supply Outage & Leakage',
  '压力表': 'Pressure Gauge',
  '请输入关键字进行查询': 'Enter keywords to search',
  '设备名称': 'Device Name',
  '设备编号': 'Device No.',
  '安装位置': 'Installation Location',
  '用户名称': 'Customer Name',
  '用户编号': 'Customer No.',
  '表编号': 'Meter No.',
  '用户姓名': 'Customer Name',
  '表安装地址': 'Meter Installation Address',
  '阀门状态': 'Valve Status',
  '运行状态': 'Running Status',
  '开阀': 'Open Valve',
  '请设置url.list属性!': 'Please set the url.list property!',
  '请设置url.pwlist属性!': 'Please set the url.pwlist property!',
  // 主框架页签
  '供水分析': 'Water Supply Analysis',
  '运营分析': 'Operations Analysis',
  '工单管理': 'Work Order Management',
  '巡检管理': 'Inspection Management',
  '抄表管理': 'Meter Reading Management'
}
